module.exports = __webpack_public_path__ + "static/media/artwork-not-found.5435f7c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/artwork-not-found.png
// module id = 410
// module chunks = 0